import { ErrorMessageContents } from '../../helpers/hub'
import { Activity } from './types'

export const activityLogFetch = () => ({ type: 'activityLog.fetch' } as const)
type ActivityLogFetchAction = ReturnType<typeof activityLogFetch>

export const activityLogFetchCancel = () =>
  ({ type: 'activityLog.fetchCancel' } as const)
type ActivityLogFetchCancelAction = ReturnType<typeof activityLogFetchCancel>

export const activityLogFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'activityLog.fetchFail', payload: error, error: true } as const)
type ActivityLogFetchFailAction = ReturnType<typeof activityLogFetchFail>

export const activityLogAddActivity = (activityLog: Activity[]) =>
  ({ type: 'activityLog.addActivity', payload: activityLog } as const)
type ActivityLogAddActivityAction = ReturnType<typeof activityLogAddActivity>

export type ActivityLogActions =
  | ActivityLogFetchAction
  | ActivityLogFetchCancelAction
  | ActivityLogFetchFailAction
  | ActivityLogAddActivityAction
